import { useEffect } from 'react'
import { idlFactory } from '@plug-core/idls/userLogger/logger.did'
import type { _SERVICE as LoggerActor } from '@plug-core/idls/userLogger/logger.did'
import { useCurrentWallet } from '@plug-core/state'
import { Actor, ActorSubclass } from '@dfinity/agent'
import getAgent from '@plug-core/utils/getAgent'
import { USER_LOGGER_CANISTER_ID } from '@plug-core/constants/canisterIds'
import { logger } from '@plug-core/logger'
import { getIdentity } from '@plug-core/handlers/walletActions/wallet'

const AccountLogger = () => {
  const { currentWallet } = useCurrentWallet()

  useEffect(() => {
    getIdentity(currentWallet)
      .then((identity) => {
        const actor = Actor.createActor(idlFactory, {
          agent: getAgent({ identity }),
          canisterId: USER_LOGGER_CANISTER_ID,
        }) as ActorSubclass<LoggerActor>

        return actor.status()
      })
      .catch(logger.debug)
  }, [currentWallet])

  return null
}

export default AccountLogger
